import React from 'react'

import Breadcrumb from 'components/Breadcrumb'

import PageTitle from './PageTitle'
import Form from './Form'

const Add = props => (
  <div className="page-content">
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <div className="row">
      <div className="col-md-12">
        <Form />
      </div>
    </div>
  </div>
)

export default Add
